import { call, take, put } from 'redux-saga/effects';
import axios               from 'axios';
import { SET_TUTORIALS }   from '../actions';
import mockTutorials       from '../content/mockContent/tutorials';

const endpoint = 'https://www.yisumatica.org.il/yisumaticaApi/getTutorials.php';


const filterTutorials = (arr: {[key:string]: any}[]) => {

    for ( let i = 0; i < arr.length; i++ ) {

      arr[i].origin = "tutorials";
      arr[i].index  = i;

      if ( arr[i].name ) {
        arr[i].name = arr[i].name.replace("\r\n", "");
      }
      if ( arr[i].title ) {
        arr[i].title = arr[i].title.replace("\r\n", "");
      }
    } 

    return arr;
}


function* getTutorials(): Generator<any,any,any> {
  while(true) {
    try {

        yield take('GET_TUTORIALS_SAGA');

        
        if (process.env.NODE_ENV === 'development') {

            yield put(SET_TUTORIALS(mockTutorials))

        }
        if (process.env.NODE_ENV === 'production') {

         // yield put(SET_TUTORIALS(mockTutorials))


             const res = yield call( axios.post, endpoint);

             if (res && res.data && res.data.result) {

                 const payload = filterTutorials(res.data.result);
                
                 yield put(SET_TUTORIALS( payload ))

               //  console.log('tutorials  : ', JSON.stringify(res.data.result, null, 2))
             }

             else {

               yield put(SET_TUTORIALS( mockTutorials ))
               console.log("can't get tutorials")
             }

            
        }
    }
    catch(err) {
      console.log('err  :  '+err);
      yield put(SET_TUTORIALS( mockTutorials ))
    }
    finally {}
  }
}


export default getTutorials;






